import { useState } from 'react';

let timeout;
/**
 * Set hover's effect on table rows in all three pages.
 * @returns {{key: string, onMove: Function, onLeave: Function}} Object with action attributes
 */
function useTableHoverRow() {
    const [ hoverId, setHoverId ] = useState();

    function onMove(id) {
        if (timeout) clearTimeout(timeout);

        setHoverId(id);
    }

    function onLeave() {
        timeout = setTimeout(() => setHoverId(null), 50);
    }

    return {
        key: hoverId,
        onMove,
        onLeave
    }
}

export default useTableHoverRow;
